import { MapPin, Phone, Mail, Instagram } from "lucide-react";
import { COMPANY, NAV_ITEMS } from "../lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="bg-[#111111] text-white relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#2F5887]/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-[#00C7A5]/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Logo + about */}
          <div className="lg:col-span-2">
            <img
              src={COMPANY.logoHorizontal}
              alt="Master Business"
              className="h-14 w-auto mb-5"
            />
            <p className="text-white/70 leading-relaxed max-w-md">
              Contabilidade estratégica para empresas que querem crescer. Soluções completas com atendimento humanizado, agilidade e segurança.
            </p>

            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://www.instagram.com/masterbusinessconsultoria"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da Master Business"
                data-testid="footer-social-instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#00C7A5] flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-[#00C7A5] mb-5">
              Navegação
            </p>
            <ul className="space-y-3">
              {NAV_ITEMS.map((n) => (
                <li key={n.id}>
                  <button
                    data-testid={`footer-nav-${n.id}`}
                    onClick={() => scrollTo(n.id)}
                    className="text-white/80 hover:text-[#00C7A5] transition-colors"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-[#00C7A5] mb-5">
              Contato
            </p>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#00C7A5] flex-shrink-0" />
                <span className="text-sm leading-relaxed">
                  {COMPANY.address.street}<br />
                  {COMPANY.address.neighborhood} — {COMPANY.address.city}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#00C7A5] flex-shrink-0" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="text-sm hover:text-white">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#00C7A5] flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="text-sm hover:text-white break-all">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-sm">
            © {year} {COMPANY.name}. Todos os direitos reservados.
          </p>
          <p className="text-white/40 text-xs">CNPJ • Consultoria Contábil em Goiânia - GO</p>
        </div>
      </div>
    </footer>
  );
}
